import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  cartRequest: ['cid'],
  cartSuccess: ['data'],
  cartFailed: ['error'],

  cartAddRequest: ['products', 'ctx'],
  cartAddSuccess: ['data'],
  cartAddFailed: ['addError'],

  changeQuantityRequest: ['product', 'changeType', 'sellerId'],
  changeQuantitySuccess: ['data'],
  changeQuantityError: ['error'],

  cartCouponRequest: ['coupon'],
  cartCouponSuccess: ['data'],
  cartCouponFailed: ['error'],

  cartRemoveCouponRequest: ['coupon'],
  cartRemoveCouponSuccess: ['data'],
  cartRemoveCouponFailed: ['error'],
});

const INITIAL_STATE = Immutable({
  isLoading: false,
  error: {},
  addLoading: false,
  addError: false,
  addSuccess: false,
  changeQuantity: {},
  couponError: {},
});

const cartRequest = (state = INITIAL_STATE) => state.merge({ isLoading: true, error: {} });

const cartAddRequest = (state = INITIAL_STATE) =>
  state.merge({ addError: false, addSuccess: false, error: {}, addLoading: true });

const cartSuccess = (state = INITIAL_STATE, { data }) => state.merge(data).set('isLoading', false);

const cartAddSuccess = (state = INITIAL_STATE, { data }) =>
  state.merge(data).set('addSuccess', true).set('addLoading', false);

const cartFailed = (state = INITIAL_STATE, { error }) => state.merge({ error, isLoading: false });

const cartAddFailed = (state = INITIAL_STATE, { addError }) => state.merge({ addError, addLoading: false });

const changeQuantityRequest = (state = INITIAL_STATE, { product }) =>
  state.merge({ error: {}, changeQuantity: { id: product.id, isLoading: true } });

const changeQuantitySuccess = (state = INITIAL_STATE, { data: { id, data } }) =>
  state.set('changeQuantity', { id, isLoading: false }).merge(data);

const changeQuantityError = (state = INITIAL_STATE, { error }) =>
  state.set('error', error).setIn(['changeQuantity', 'isLoading'], false);

const cartCouponFailed = (state = INITIAL_STATE, { error }) => state.merge({ couponError: error, isLoading: false });

export default createReducer(INITIAL_STATE, {
  [Types.CART_REQUEST]: cartRequest,
  [Types.CART_SUCCESS]: cartSuccess,
  [Types.CART_FAILED]: cartFailed,

  [Types.CART_ADD_REQUEST]: cartAddRequest,
  [Types.CART_ADD_SUCCESS]: cartAddSuccess,
  [Types.CART_ADD_FAILED]: cartAddFailed,

  [Types.CHANGE_QUANTITY_REQUEST]: changeQuantityRequest,
  [Types.CHANGE_QUANTITY_SUCCESS]: changeQuantitySuccess,
  [Types.CHANGE_QUANTITY_ERROR]: changeQuantityError,

  [Types.CART_COUPON_REQUEST]: cartRequest,
  [Types.CART_COUPON_SUCCESS]: cartSuccess,
  [Types.CART_COUPON_FAILED]: cartCouponFailed,

  [Types.CART_REMOVE_COUPON_REQUEST]: cartRequest,
  [Types.CART_REMOVE_COUPON_SUCCESS]: cartSuccess,
  [Types.CART_REMOVE_COUPON_FAILED]: cartCouponFailed,
});
